/* NBB — Slideshow numbered pager: make the active pink chip GLIDE between
   numbers. Tracks the active bullet's position into CSS vars (--nbb-pg-x / -w)
   on the .slideshow__pagination-number container; the chip (::before, styled in
   nbb-chrome-ui.css §38) transitions transform → it slides across on change.
   REVERT: delete this file + its <script> tag in snippets/color-scheme-vars.liquid
   + the §38 block in nbb-chrome-ui.css. */
(function () {
  function place(container, force) {
    var active = container.querySelector('.swiper-pagination-bullet-active');
    if (!active) return;
    // CWV: offsetLeft/offsetWidth force a full-page reflow; Swiper fires several
    // class mutations per transition, so only pay that cost when the active
    // bullet actually moved (or on resize, where positions change in place).
    if (!force && container.__nbbActive === active) return;
    container.__nbbActive = active;
    container.style.setProperty('--nbb-pg-x', active.offsetLeft + 'px');
    container.style.setProperty('--nbb-pg-w', active.offsetWidth + 'px');
    container.classList.add('nbb-pg-ready');
  }
  function init(container) {
    if (container.__nbbPager) return;
    container.__nbbPager = true;
    var raf;
    var obs = new MutationObserver(function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { place(container); });
    });
    obs.observe(container, { subtree: true, attributes: true, attributeFilter: ['class'] });
    place(container);
    window.addEventListener('resize', function () { place(container, true); });
  }
  function scan() {
    document
      .querySelectorAll('.section-slideshow .slideshow__pagination-number')
      .forEach(init);
  }
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  // Swiper may build the bullets after DOMContentLoaded — re-scan shortly after.
  setTimeout(scan, 400);
  setTimeout(scan, 1200);
})();
